import { render, staticRenderFns } from "./MarginSeatModal.vue?vue&type=template&id=b21d2382"
import script from "./MarginSeatModal.vue?vue&type=script&lang=js"
export * from "./MarginSeatModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports